<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <div class="row">
                @if (getAdditionalQuestions(parameters, 'RETIREMENT_AGE')) {
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Age de départ à la retraite"
                      [derrors]="derrors"
                    >
                      <input
                        notdot
                        formControlName="retirementAge"
                        type="number"
                        placeholder="Exemple : 64"
                      />
                    </pr-input-column>
                  </div>
                }
              </div>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
